import React, { useContext } from "react";
import { Link, useHistory, useLocation } from "react-router-dom";
import UserContext from "../State/UserContext";
import LogoImg from "./assets/images/Logo-PNG.png";
import UserPrincipalImg from "./assets/user_principal.png";
import { ReactComponent as UserSvg } from "./assets/user.svg";
import { ReactComponent as FacturacionSvg } from "./assets/facturacion.svg";
import { ReactComponent as HistoricoFacturacionSvg } from "./assets/historico_facturacion.svg";
import { ReactComponent as ConsultaPadronSvg } from "./assets/consulta_padron.svg";
import { ReactComponent as ConfiguracionSvg } from "./assets/configuracion.svg";
import { ReactComponent as LogoutSvg } from "./assets/icons/logout.svg";

const UserIcon = ({ color = "#004890" }) => (
  <UserSvg style={{ width: 20, height: 20, color, flexShrink: 0 }} />
);
const FacturacionIcon = ({ color = "#004890" }) => (
  <FacturacionSvg style={{ width: 20, height: 20, color, flexShrink: 0 }} />
);
const HistoricoFacturacionIcon = ({ color = "#004890" }) => (
  <HistoricoFacturacionSvg style={{ width: 20, height: 20, color, flexShrink: 0 }} />
);
const ConsultaPadronIcon = ({ color = "#004890" }) => (
  <ConsultaPadronSvg style={{ width: 20, height: 20, color, flexShrink: 0 }} />
);
const ConfiguracionIcon = ({ color = "#004890" }) => (
  <ConfiguracionSvg style={{ width: 20, height: 20, color, flexShrink: 0 }} />
);
const LogoutIcon = ({ color = "#2979BD" }) => (
  <LogoutSvg style={{ width: 20, height: 20, color, flexShrink: 0 }} />
);

const Roles = {
  SuperAdmin: "AdminHB",
  Admin: "Facturacion",
  User: "Prestador",
};

function MenuItem({ to, label, icon: Icon, active }) {
  const color = active ? "#004890" : "rgba(0, 72, 144, 0.5)";
    return (
      <div style={{ paddingLeft: 25, paddingRight: 25 }}>
      <Link
        to={to}
        style={{
          display: "flex",
          alignItems: "center",
          gap: 14,
          width: "100%",
          padding: "20px 0px",
          background: "none",
          border: "none",
          cursor: "pointer",
          fontSize: 14,
          fontWeight: active ? 700 : 400,
          color,
          transition: "all 0.15s",
          textDecoration: "none",
          fontSize: 16,
        }}
      >
        {Icon ? <Icon color={color} /> : null}
        {label}
      </Link>
      <div style={{ height: 1, backgroundColor: "rgba(74, 111, 150, 0.5)" }} />
    </div>
  );
}

export { Roles };

export default function Sidebar() {
  const history = useHistory();
  const location = useLocation();
  const { user, setUser } = useContext(UserContext);

  async function logout() {
    setUser({});
    history.push("/");
  }

  const isAdmin = user.user?.rol?.name === Roles.Admin;
  const isNotUser = user.user?.rol?.name !== Roles.User;
  const hasPadron = user.user?.padron === "S";

  return (
    <aside
      style={{
        width: 260,
        backgroundColor: "#ffffff",
        borderRadius: "0 20px 0 0",
        boxShadow: "2px 0 16px rgba(0,0,0,0.07)",
        display: "flex",
        flexDirection: "column",
        padding: "28px 0",
        fontFamily: "'Segoe UI', 'Roboto', 'Arial', sans-serif",
        position: "sticky",
        height: "100vh",
        overflow: "hidden",
        margin: 0,
      }}
    >
      {/* Logo */}
      <div style={{ display: "flex", justifyContent: "center", flexShrink: 0, marginBottom: "clamp(16px, 4vh, 56px)", padding: "0 16px" }}>
        <img src={LogoImg} alt="Plan de Salud - H+B Medicina Prepaga" style={{ maxWidth: "100%", maxHeight: 80, objectFit: "contain", display: "block" }} />
      </div>

      {/* User */}
      <div style={{ display: "flex", alignItems: "center", flexShrink: 0, gap: 12, padding: "0 24px", marginBottom: "clamp(16px, 4vh, 52px)" }}>
        <img
          src={UserPrincipalImg}
          alt="Usuario"
          style={{
            width: 44,
            height: 44,
            borderRadius: "50%",
            objectFit: "cover",
            flexShrink: 0,
          }}
        />
        <div>
          <div style={{ fontSize: 14, fontWeight: 600, color: "#212121" }}>
            {user.user?.name ? `${user.user.name} ${user.user?.lastName || ""}`.trim() : user.user?.email}
          </div>
          <div style={{ fontSize: 12, color: "#9E9E9E" }}>{user.user?.rol?.name || "—"}</div>
        </div>
      </div>

      {/* Menu */}
      <nav style={{ flex: 1, minHeight: 0, overflowY: "auto", display: "flex", flexDirection: "column", gap: 0, margin: 0 }}>
        <MenuItem
          to="/Socios"
          label="Afiliados"
          icon={UserIcon}
          active={location.pathname === "/Socios"}
        />
        {isAdmin && (
          <MenuItem
            to="/Facturacion"
            label="Facturación"
            icon={FacturacionIcon}
            active={location.pathname === "/Facturacion"}
          />
        )}
        {isAdmin && (
          <MenuItem
            to="/FacturacionHistory"
            label="Histórico Facturación"
            icon={HistoricoFacturacionIcon}
            active={location.pathname === "/FacturacionHistory"}
          />
        )}
        {hasPadron && (
          <MenuItem
            to="/Padron"
            label="Consulta Padrón"
            icon={ConsultaPadronIcon}
            active={location.pathname === "/Padron"}
          />
        )}
        {isNotUser && (
          <MenuItem
            to="/Gestion"
            label="Configuración"
            icon={ConfiguracionIcon}
            active={location.pathname === "/Gestion"}
          />
        )}
      </nav>

      {/* Cerrar sesión */}
      <div style={{ flexShrink: 0, padding: "16px 24px 8px", display: "flex", justifyContent: "center" }}>
        <button
          type="button"
          onClick={logout}
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: 14,
            background: "none",
            border: "none",
            cursor: "pointer",
            fontSize: 14,
            color: "#2979BD",
            padding: "10px 4px",
          }}
        >
          <LogoutIcon color="#2979BD" />
          Cerrar sesión
        </button>
      </div>
    </aside>
  );
}
